import {ApiProblem} from "./api";
import type {Locale} from "./types";

export function caseName(name: string, locale: Locale): string {
  return locale === "zh-CN" ? name.replace(/^Case ([A-Z]+)$/, "算例 $1") : name;
}
export function caseIdentifier(name: string): string {
  return name.replace(/^算例 ([A-Z]+)$/, "Case $1");
}
export function targetName(symbol: string, locale: Locale): string {
  return symbol === "custom" && locale === "zh-CN" ? "自定义" : symbol;
}
export function sourceText(source: string, locale: Locale): string {
  if (locale !== "zh-CN") return source;
  return source.replace("parameter table", "材料参数表")
    .replace("empirical physical sputtering extension", "物理溅射经验公式扩展")
    .replace("user supplied research parameters", "用户填写的材料参数")
    .replace("user-supplied research parameters", "用户填写的材料参数");
}
export function warningText(code: string, locale: Locale): string {
  if (locale !== "zh-CN") return code;
  const known: Record<string, string> = {
    PWSO_WARNING_PARAMETER_SUPPORTED: "此组合按文献参数计算，尚未逐一与实验结果核对。",
    PWSO_WARNING_CUSTOM_UNQUALIFIED: "当前使用自定义材料参数，请自行核对参数来源和适用范围。",
  };
  return known[code] ?? `计算返回了一条提示，请保留代码以便排查：${code}`;
}
export function errorText(error: unknown, locale: Locale): string {
  if (locale !== "zh-CN") return error instanceof Error ? error.message : "The request could not be completed.";
  if (!(error instanceof ApiProblem)) return "暂时无法连接服务，请检查网络后重试。";
  const code = error.code;
  let message = "未能完成请求，请稍后重试。";
  if (error.status === 401) message = /LOGIN|CREDENTIAL|INVALID/.test(code) ? "用户名或密码不正确，请重新输入。" : "请先登录；如果已经登录，请重新登录后再试。";
  else if (error.status === 403) message = "登录状态校验未通过，请刷新页面后重新登录。";
  else if (error.status === 429) message = "操作有些频繁，请稍等片刻再试。";
  else if (/TIMEOUT/.test(code) || error.status === 504) message = "计算超时，请减少采样点数或一次计算的算例数后重试。";
  else if (/BUDGET|WORK|EXPENSIVE/.test(code) || error.status === 413) message = "本次计算量超过限制，请减少算例数、温度采样点数或积分点数。";
  else if (error.status === 422 || error.status === 400) message = "部分参数不符合要求，请检查取值和上下限。";
  else if (error.status >= 500) message = "计算服务未能完成请求，请检查参数是否过大或过小，也可以稍后重试。";
  return `${message}（错误代码：${code}）`;
}
